import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  TablePagination,
  Paper,
  Select,
  Divider, DialogActions, TextField, DialogContent,
  Button,
  Grid,
  IconButton,
  Box,
  // Modal,
  Form,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faPlus } from "@fortawesome/free-solid-svg-icons";

import { Modal, ModalBody, ModalTitle } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import EditIcon from "@mui/icons-material/Edit"; // Corrected Import
import DeleteIcon from "@mui/icons-material/Delete"; // Corrected Import
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import axios from '../../Axiosinstance'
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../../common';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReactQuill from 'react-quill';
import Header from '../../components/Header';
import { decryptData } from "../../Axiosinstance";

const Managec = () => {
  const [moduleContents, setModuleContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [moduleName, setModuleName] = useState('');
  const [isNameValid, setIsNameValid] = useState(true);
  const [fileName, setFileName] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [selectedModule, setSelectedModule] = useState('');
  const [selectedFileType, setSelectedFileType] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [modalContent, setModalContent] = useState(null);
  const [materialContent, setMaterialContent] = useState(null);
  const [editModalContent, setEditModalContent] = useState(null);
  const [editMaterialContent, setEditMaterialContent] = useState(null);
  const [editingFileId, setEditingFileId] = useState(null);
  const [editedFileName, setEditedFileName] = useState('');
  const [fileUploaded, setFileUploaded] = useState(false);
  const [batchData, setBatchData] = useState(null);
  const { batchId: encodedBatchId } = useParams(); // Get encoded batchId
  const batchId = decryptData(decodeURIComponent(encodedBatchId)); // Decode & Decrypt
  const [loadingButton, setLoadingButton] = useState(false);

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const fetchBatchData = async () => {
    try {
      const response = await axios.get(`batch/${batchId}`);
      setBatchData(response.data);
      console.log(response.data, "newdata");
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    const fetchModuleContents = async () => {
      try {
        const response = await axios.get(`/module-content/batch/${batchId}`);
        console.log(response.data); // Log the response to check its structure
        setModuleContents(response.data);
      } catch (err) {
        setError('Failed to fetch module contents');
      } finally {
        setLoading(false);
        fetchBatchData();
      }
    };


    fetchModuleContents();
  }, [batchId]); // Run effect when batchId changes

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const handleNewButtonClick = () => {
    setShowPopup(true);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setModuleName(value);
    setIsNameValid(value.trim() !== ''); // Validate input
  };

  const handleSavePopup = async () => {
    if (!isNameValid) return; // Prevent submission if invalid

    try {
      const newModule = {
        name: moduleName,
        batchId: batchId, // Use the current batchId
      };

      await axios.post('/module-content', newModule); // Adjust the endpoint as necessary
      setModuleContents([...moduleContents, newModule]); // Update state with the new module
      setModuleName(''); // Clear input
      setShowPopup(false); // Close popup
      window.location.reload();
    } catch (error) {
      setError('Failed to save module content');
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setModuleName(''); // Clear input on close
    setIsNameValid(true); // Reset validation state
  };

  const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload";
  const CLOUDINARY_UPLOAD_PRESET = "vldqgwk8";

  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("public_id", "LMS/courses/" + file.name);

      const response = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.secure_url) {
        setFileUrl(data.secure_url);
        console.log(data.secure_url)
        setFileUploaded(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFormSubmit = async (event) => {

    event.preventDefault();
    if (loadingButton) return;
    setLoadingButton(true);

    const payload = {
      fileName: fileName,
      // fileUrl: fileUrl,
      fileUrl: (selectedFileType === 'youtube link' || selectedFileType === 'text') ? inputValue : fileUrl,
      moduleContent: { id: selectedModule },
      type: selectedFileType
    };

    try {
      await axios.post('/study-materials', payload);
      // Reset fields after submission
      setFileName('');
      setFileUrl('');
      setSelectedModule('');
      setInputValue('');
      setSelectedFileType('');
      setSelectedFile(null);
      setFileUploaded(false);
      window.location.reload();
    } catch (error) {
      setError('Failed to upload study material');
      // setFileUploaded(false);
    } finally {
      setLoadingButton(false); // Re-enable button after request completion
    }
  };

  const handleModuleSelect = (module) => {
    setShowModal(true);
    setModalContent(module);
  };



  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseModal = () => {
    setModalContent(null);
    setShowModal(false);
    setMaterialContent(null);

  };

  const handleMaterialClick = (file) => {
    // setShowModal(true);
    console.log(file);
    setMaterialContent(file);
  };

  const handleClickOpen = (file) => {
    console.log(file)
    setOpen(true);
    setEditMaterialContent(file)
  };

  const renderIframeContent = (content) => {
    switch (content.type) {
      case 'pdf': // PDF files
        return (
          <iframe
            src={content.fileUrl}
            style={{ width: '100%', height: '100%' }}
            title="PDF Viewer"
          ></iframe>
        );
      case 'ppt': // PowerPoint files
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(content.fileUrl)}`}
            style={{ width: '100%', height: '100%' }}
            title="PowerPoint Viewer"
          ></iframe>
        );
      case 'video': // Video files
        return (
          <video width="100%" height="auto" controls>
            <source src={content.fileUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      case 'youtube link': // YouTube links
        return (
          <iframe
            src={content.fileUrl.replace("youtu.be", "www.youtube.com/embed").split("?")[0]} // Convert to embeddable format
            style={{ width: '100%', height: '100%' }}
            title="YouTube Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      case 'text': // Plain text or HTML content
        return (
          <div
            style={{
              padding: '10px',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
            }}
            dangerouslySetInnerHTML={{ __html: content.fileUrl }}
          ></div>
        );
      default: // Unsupported formats
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              Unsupported format: {content.type}
            </p>
          </div>
        );
    }
  };


  const handleEdit = (module) => {
    setShowEditModal(true);
    setEditModalContent(module);
  };

  const handlecloseEditModal = () => {
    setShowEditModal(false);
    setEditModalContent(null);
  };

  // const handleCloseModal = () => {
  //   setModalContent(null);
  //   setShowModal(false);

  // };

  const handleSaveChanges = async (fileId) => {
    try {
      // Find the original file object to retain other properties
      const originalFile = modalContent.files.find((file) => file.id === fileId);

      // Prepare the updated data
      const updatedData = {
        fileName: editedFileName, // Updated file name
        fileUrl: originalFile.fileUrl, // Retain original file URL
        type: originalFile.type // Retain original file type
      };

      // Make an API call to update the file name
      await axios.put(`study-materials/${fileId}`, updatedData);

      // Optionally refresh data or notify the user
      console.log('File updated successfully:', updatedData);
      window.location.reload();
      setEditingFileId(null); // Exit editing mode
    } catch (error) {
      console.error('Error updating file:', error);
      // Optionally, show an error message to the user
    }
  };

  const handleDelete = async (fileId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this file?");
    if (confirmDelete) {
      try {
        await axios.delete(`study-materials/${fileId}`);
        console.log(`File with ID ${fileId} deleted successfully.`);
        window.location.reload();
      } catch (error) {
        console.error('Error deleting file:', error);
      }
    }
  };
  const handleDeletemodelContent = async (id) => {
    console.log(id)
    const confirmDelete = window.confirm("Are you sure you want to delete this module?");
    if (confirmDelete) {
      try {
        await axios.delete(`module-content/${id}`);
        console.log(`Module with ID ${id} deleted successfully.`);
        window.location.reload();
        // Optionally, you may want to refresh the data or update the state here
      } catch (error) {
        console.error('Error deleting module:', error);
      }
    }
  };

  // const handleFieldChange = (e) => {
  //   console.log(e.target)
  //   const { name, value } = e.target;
  //   setEditMaterialContent(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };

  const handleEditClick = (file) => {
    setEditingFileId(file.id); // Set the ID of the file being edited
    setEditedFileName(file.fileName); // Set the current file name to edit
  };

  const handleEditInputChange = (e) => {
    setEditedFileName(e.target.value); // Update the input value
  };

  const handleCancelEdit = () => {
    setEditingFileId(null); // Exit editing mode without saving
  };


  const handleSavemodule = async () => {
    try {
      // Update the module content on the server
      const response = await axios.put(`module-content/${editModalContent.id}`, editModalContent);

      // Update the local state with the response data
      setModuleContents(prevContents =>
        prevContents.map(module =>
          module.id === editModalContent.id ? response.data : module
        )
      );
      window.location.reload();
      console.log('Updated module content:', response.data);
      setShowEditModal(false); // Close the modal
    } catch (error) {
      console.error('Error saving module content:', error);
    }
  };

  const getAcceptTypes = () => {
    switch (selectedFileType) {
      case 'ppt':
        return '.ppt';
      case 'pdf':
        return '.pdf';
      case 'mp4':
        return '.mp4';
      case 'mp3':
        return '.mp3';
      case 'txt':
        return '.txt';
      default:
        return '';
    }
  };


  const renderInputField = () => {
    if (selectedFileType === 'youtube link') {
      return (
        <div className="mb-3">
          <label htmlFor="youtubeLink" className="form-label">
            Paste YouTube Link
          </label>
          <input
            type="text"
            id="youtubeLink"
            className="form-control"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      );
    } else if (selectedFileType === 'text') {
      return (
        <div className="mb-3">
          <label htmlFor="textInput" className="form-label">
            Enter Text
          </label>
          <ReactQuill
            value={inputValue}
            onChange={setInputValue}
            modules={{
              toolbar: [
                [{ header: '1' }, { header: '2' }, { font: [] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['bold', 'italic', 'underline'],
                ['link'],
                [{ align: [] }],
              ],
            }}
            formats={[
              'header',
              'font',
              'list',
              'bullet',
              'bold',
              'italic',
              'underline',
              'link',
              'align',
            ]}
          />
        </div>
      );
    }
    return null;
  };





  return (
    <div>
      <Header />
      <br />
      <div className="containere" style={{ maxWidth: '100%', padding: '0px 16px' }}>


        <Box
          sx={{
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            borderRadius: "8px",
            width: "100%",
            maxWidth: "1000px",
            margin: "auto",
          }}
        >

          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#007bff", color: "white" }}
              onClick={() => window.history.back()}
            >
              All Courses
            </Button>
          </Box>
          <div
            className="mb-4 d-flex justify-content-between align-items-center"
            style={{
              borderBottom: "2px solid #03396c",
              paddingBottom: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Title */}
            <Typography
              variant="h5"
              sx={{
                color: "#03396c",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FontAwesomeIcon icon={faLayerGroup} style={{ color: "#005b96", fontSize: "1.4rem" }} />
              New Module
            </Typography>

            {/* Button */}
            <Button
              onClick={handleNewButtonClick}
              sx={{
                background: "linear-gradient(90deg, #03396c, #005b96)",
                color: "white",
                padding: "10px 22px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: "bold",
                textTransform: "none",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                "&:hover": {
                  background: "linear-gradient(90deg, #022c5b, #004080)", // Darker on hover
                },
              }}
            >
              <FontAwesomeIcon icon={faPlus} style={{ fontSize: "1.2rem" }} />
              <span style={{ fontSize: "1rem" }}>New</span>
            </Button>
          </div>


          {showPopup && (
            <div
              style={{
                boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)", // Softer shadow
                padding: "16px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                gap: "12px", // Spacing between elements
                width: "100%",
                maxWidth: "1000px", // Controls width
                margin: "auto",
              }}
            >
              {/* Module Dropdown */}
              <TextField
                select
                label="Select Module"
                value={moduleName}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                sx={{
                  flex: 1, // Takes remaining space
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                {batchData?.moduleDetails && batchData?.moduleDetails.length > 0 ? (
                  batchData.moduleDetails.map((module) => {
                    const isDisabled = moduleContents.some(
                      (selectedModule) => selectedModule.name === module.moduleName
                    );
                    return (
                      <MenuItem key={module.id} value={module.moduleName} disabled={isDisabled}>
                        {module.moduleName}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem disabled>No modules available</MenuItem>
                )}
              </TextField>

              {/* Validation Message */}
              {!isNameValid && (
                <Typography
                  variant="body2"
                  color="error"
                  sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                >
                  Invalid Module Name
                </Typography>
              )}

              {/* Buttons */}
              <Button
                onClick={handleSavePopup}
                variant="contained"
                color="primary"
                sx={{ borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
              >
                Save
              </Button>
              <Button
                onClick={handleClosePopup}
                variant="contained"
                color="error"
                sx={{ borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
              >
                Cancel
              </Button>
            </div>
          )}



          <TableContainer component={Paper} style={{ margin: '20px auto', maxWidth: '100%' }}>
            <Table>
              {/* Table Head */}
              <TableHead>
                <TableRow style={{ backgroundColor: '#f4f7fc' }}>
                  <TableCell style={{ fontWeight: 'bold', color: '#03396c' }}>Name</TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold', color: '#03396c' }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              {/* Table Body */}
              <TableBody>
                {moduleContents
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((module) => (
                    <TableRow key={module.id} hover>
                      <TableCell>{module.name}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="primary"
                          onClick={() => handleEdit(module)}
                          title="Edit"
                          style={{ transition: 'transform 0.2s', marginRight: 8 }}
                          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDeletemodelContent(module.id)}
                          title="Delete"
                          style={{ transition: 'transform 0.2s' }}
                          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            {/* Pagination */}
            <TablePagination
              rowsPerPageOptions={[4, 8, 12]}
              component="div"
              count={moduleContents.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
          <div className="">
            <h3 className="mb-3" style={{ color: '#03396c', fontWeight: 'bold' }}>Upload Study Material</h3>
            <Divider />
            <br />
            <form onSubmit={handleFormSubmit}>
              <div className="mb-3">
                <label htmlFor="fileName" className="form-label">Content Name</label>
                <input
                  required
                  type="text"
                  id="fileName"
                  className="form-control"
                  placeholder="Enter File Name"
                  value={fileName}
                  onChange={(e) => {
                    setFileName(e.target.value);
                    console.log('File Name:', e.target.value); // Log file name
                  }}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="moduleContent" className="form-label">Module</label>
                <select
                  required
                  id="moduleContent"
                  className="form-select"
                  value={selectedModule}
                  onChange={(e) => {
                    setSelectedModule(e.target.value);
                    console.log('Selected Module:', e.target.value); // Log selected module
                  }}
                >
                  <option value="">Select a Module</option>
                  {moduleContents.map((modulecontent) => (
                    <option key={modulecontent.id} value={modulecontent.id}>
                      {modulecontent.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="type" className="form-label">Type</label>
                <select
                  required
                  id="type"
                  className="form-select"
                  value={selectedFileType}
                  onChange={(e) => {
                    setSelectedFileType(e.target.value);
                    console.log('Selected File Type:', e.target.value); // Log selected file type
                  }}
                >
                  <option value="">Select a type</option>
                  <option value="ppt">PPT</option>
                  <option value="pdf">PDF</option>
                  <option value="video">Video</option>
                  {/* <option value="audio">Audio</option> */}
                  <option value="youtube link">YouTube Link</option>
                  {/* <option value="text">Text</option> */}
                </select>
              </div>
              {/* <div className="mb-3">
                <label htmlFor="file" className="form-label">Upload File</label>
                <input
                  required
                  type="file"
                  id="file"
                  className="form-control"
                  accept=".ppt,.pdf,.mp4,.mp3,.txt"
                  onChange={(e) => {

                    handleImageUpload(e); // Trigger image upload function
                  }}
                />
              </div> */}
              {renderInputField()}

              {selectedFileType &&
                selectedFileType !== 'youtube link' &&
                selectedFileType !== 'text' && (
                  <div className="mb-3">
                    <label htmlFor="file" className="form-label">
                      Choose {selectedFileType.toUpperCase()} file
                    </label>
                    <input
                      required
                      type="file"
                      id="file"
                      className="form-control"
                      // accept={getAcceptTypes()}
                      // onChange={(e) => {
                      //   handleImageUpload(e); // Trigger image upload function
                      // }}
                      onChange={(event) => {
                        const file = event.target.files[0];
                        if (file && file.size > 8 * 1024 * 1024) {
                          event.target.value = ""; // Reset file input
                          alert("File size must be less than 8MB.");
                        } else {
                          handleImageUpload(event);
                        }
                      }}
                    />
                    {/* {isUploading && <p>Uploading...</p>} */}
                  </div>
                )}

              <div className="d-flex justify-content-end">
                <Button
                  type="submit"
                  variant='contained'
                  disabled={loadingButton || (!fileUploaded && selectedFileType !== "youtube link" && selectedFileType !== "text")}
                  style={{


                    borderRadius: '6px',
                    padding: '10px 20px',
                  }}
                >
                  {loadingButton ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </form>
          </div>
          <div>
            <h3 style={{ color: '#03396c', fontWeight: 'bold' }}>Courses Notes</h3>
            <Divider />
            <br />
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap", // Allows buttons to wrap to new rows
                gap: "16px",
                justifyContent: "center", // Centers buttons properly
              }}
            >
              {moduleContents?.length > 0 ? (
                moduleContents.map((item) => (
                  <Button
                    key={item.id}
                    variant="contained"
                    color="primary"
                    sx={{
                      flex: "1 1 200px", // Makes buttons flexible with a min-width of 200px
                      height: "60px", // Uniform height
                      fontSize: "16px",
                      textTransform: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      whiteSpace: "normal",
                      maxWidth: "300px", // Prevents buttons from getting too wide
                    }}
                    onClick={() => handleModuleSelect(item)}
                  >
                    {item.name}
                  </Button>
                ))
              ) : (
                <Typography variant="h6" sx={{ textAlign: "center", color: "gray" }}>
                  No modules available
                </Typography>
              )}
            </Box>

          </div>
        </Box>
      </div>
      <Modal fullscreen show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Module Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 style={{ color: '#03396c', fontWeight: 'bold' }}>Study Materials:</h4>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="study materials table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ color: '#03396c', fontWeight: 'bold' }}>File Name</TableCell>
                  <TableCell style={{ color: '#03396c', fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {modalContent?.files?.map((file) => (
                  <TableRow
                    key={file.id}
                    sx={{ '&:hover': { cursor: 'pointer', backgroundColor: '#f5f5f5' } }}
                  >
                    <TableCell style={{ color: '#03396c' }} onClick={() => handleMaterialClick(file)} >
                      {editingFileId === file.id ? (
                        <TextField
                          value={editedFileName}
                          onChange={handleEditInputChange}
                          variant="outlined"
                          size="small"
                        />
                      ) : (
                        <span>{file.fileName}</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {editingFileId === file.id ? (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleSaveChanges(file.id)}
                            style={{ marginRight: '10px' }}
                          >
                            Submit
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleCancelEdit}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <>
                          {/* 🔥 VIEW BUTTON */}
                          <Button
                            variant="contained"
                            color="success"
                            onClick={() => handleMaterialClick(file)}
                            style={{ marginRight: '8px' }}
                          >
                            View
                          </Button>

                          {/* EDIT */}
                          <IconButton color="primary" onClick={() => handleEditClick(file)}>
                            <EditIcon />
                          </IconButton>

                          {/* DELETE */}
                          <IconButton color="secondary" onClick={() => handleDelete(file.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>


          </TableContainer>
          {materialContent && renderIframeContent(materialContent)}
        </Modal.Body>
      </Modal>

      {/* <Dialog open={open} onClose={handleClose} aria-labelledby="edit-dialog-title">
        <DialogTitle id="edit-dialog-title">Edit Details</DialogTitle>

        <DialogContent>
          {editMaterialContent && (
            <form>
              <TextField
                fullWidth
                margin="normal"
                label="fileName"
                variant="outlined"
                type="text"
                name="fileName"
                value={editMaterialContent.fileName || ''} // Bind the file name
                onChange={handleFieldChange}
                required
              />
              <Select
                fullWidth
                margin="normal"
                label="Type"
                variant="outlined"
                name="type"
                value={editMaterialContent.type || ''} // Bind the type
                onChange={handleFieldChange}
                required
              >
                <MenuItem value="Text">Text</MenuItem>
                <MenuItem value="YouTube Link">YouTube Link</MenuItem>
                <MenuItem value="Audio">Audio</MenuItem>
                <MenuItem value="Video">Video</MenuItem>
                <MenuItem value="PDF">PDF</MenuItem>
                <MenuItem value="PPT">PPT</MenuItem>
              </Select>
              <TextField
                fullWidth
                margin="normal"
                label="File URL"
                variant="outlined"
                type="text"
                name="fileUrl"
                value={editMaterialContent.fileUrl || ''} // Bind the file URL
                onChange={handleFieldChange}
                required
              />
            </form>
          )}
        </DialogContent>

        <DialogActions>
          <Button type="submit" variant="contained" onClick={handleSaveChanges} style={{ marginRight: '10px' }}>
            Save Changes
          </Button>
          <Button variant="contained" onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog> */}


      {/* //module name outside */}
      <Modal centered show={showEditModal} onHide={handlecloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Module Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            label=" Module Name"
            variant="outlined"
            fullWidth
            value={editModalContent?.name || ''}
            onChange={(e) => setEditModalContent({ ...editModalContent, name: e.target.value })}
          />
          <Button
            variant="contained"
            style={{ backgroundColor: 'green', color: "white", marginTop: '16px', }}
            onClick={handleSavemodule}

          >
            Save
          </Button>
        </Modal.Body>
      </Modal>
    </div>

  );
};


export default Managec;
